/** Filterable paged list of a tenant's invoices. */
export const tenantBillingInvoiceListSpec = {
    uri: '/t/[tenant]/billing/invoice',
    method: 'GET',
};
